import React from 'react';

// import { Container } from './styles';

const Contacts = () => {
  return <div>Contacts</div>;
};

export default Contacts;
